var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMultiBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 220 110",
    width: 220,
    height: 110,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#1F3864",
    strokeWidth: 2.5,
    strokeDasharray: "7 6",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 15,
    width: 206,
    height: 80,
    rx: 11
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 33,
    width: 50,
    height: 44,
    rx: 3,
    fill: "#C49359",
    stroke: "#A87A43",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 48 H76",
    stroke: "#A87A43",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 33,
    width: 10,
    height: 15,
    fill: "#DDBD8F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 33,
    width: 50,
    height: 44,
    rx: 3,
    fill: "#C49359",
    stroke: "#A87A43",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 48 H135",
    stroke: "#A87A43",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 33,
    width: 10,
    height: 15,
    fill: "#DDBD8F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 33,
    width: 50,
    height: 44,
    rx: 3,
    fill: "#C49359",
    stroke: "#A87A43",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144 48 H194",
    stroke: "#A87A43",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 33,
    width: 10,
    height: 15,
    fill: "#DDBD8F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiBox);
export default __webpack_public_path__ + "static/media/MultiBox.d002df8d4053e5dc182a109c02d3b6cb.svg";
export { ForwardRef as ReactComponent };